import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { type AppState, type BaseAppState, type EntityRef, Status } from "@client/types";
import appInfo from "@common/appInfo";
import { toOptionItems } from "@common/lib/api";
import Network from "@common/modules/network/types";
import { type Dispatch } from "redux";
import { initAction } from "../actions";
import api from "./api";
import { localStateSelector } from "./selectors";
import { type MemberAffiliateDashboard } from "./types";

export enum Actions {
  InitBegin = "MEMBER_AFFILIATE_DASHBOARD_INIT_BEGIN",
  InitFailure = "MEMBER_AFFILIATE_DASHBOARD_INIT_FAILURE",
  InitSuccess = "MEMBER_AFFILIATE_DASHBOARD_INIT_SUCCESS"
}

export type InitBeginActionData = EntityRef & {
  join?: boolean;
};
export type InitSuccessActionData = MemberAffiliateDashboard.Api.InitResponse;
export const _init = initAction<
  BaseAppState,
  InitBeginActionData,
  MemberAffiliateDashboard.Api.InitResponse,
  InitSuccessActionData
>({
  types: {
    begin: Actions.InitBegin,
    failure: Actions.InitFailure,
    success: Actions.InitSuccess
  },
  action: (state: AppState, dispatch: any, params: InitBeginActionData) => {
    const apiInfo = makeModuleApiInfoSelector()(state, params);
    return api.init(apiInfo, params.join);
  },
  mapResponse: (state: AppState, resp: MemberAffiliateDashboard.Api.InitResponse) => {
    return {
      dashboard: resp.dashboard
        ? {
            ...resp.dashboard,
            cycleOptions: toOptionItems<string>(resp.dashboard.cycleOptions) as Network.Cycles.Api.CycleOption[]
          }
        : null
    };
  }
});

export type InitArgs = EntityRef;
export const init = (args: InitArgs, join?: boolean) => (dispatch: Dispatch<any>, getState: () => BaseAppState) => {
  const state = getState();
  const localState = localStateSelector(state, args);

  if (!appInfo.user) return;

  if (localState.status === Status.None || join) {
    dispatch(
      _init({
        ...args,
        join
      })
    );
  }
};
